// Copyright (c) 2022 Deere & Company

const closingAccountFilterOptions = [
    ['account'],
    ['account', 'name'],
    ['account', 'industryIndicator'],
    ['account', 'account'],
    ['account', 'location']

];

export default closingAccountFilterOptions;



// WEBPACK FOOTER //
// ./src/tcsm/wip/services/closing-account-filter-options.js